import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const NO_PARAMS = [];

export function findUrlTab(tabs, value) {
  if (value == null || value === "") return -1;
  const raw = String(value);
  const index = /^\d+$/.test(raw) ? Number(raw) : tabs.findIndex((tab) =>
    tab.tabKey === raw || tab.name === raw || tab.aliases?.includes(raw)
  );
  return tabs[index] && tabs[index].active !== false ? index : -1;
}

/** URL is the source of truth; only an explicit tab selection writes history. */
export function useUrlTab(tabs, { overrideTab, clearParams = NO_PARAMS, mergeSearchParams } = {}) {
  const location = useLocation();
  const navigate = useNavigate();
  const overrideIndex = findUrlTab(tabs, overrideTab);
  const urlIndex = findUrlTab(tabs, new URLSearchParams(location.search).get("tab"));
  const fallback = tabs.findIndex((tab) => tab.active !== false && !tab.onSelect);
  const selectedTab = overrideIndex >= 0 ? overrideIndex : urlIndex >= 0 ? urlIndex : fallback;

  const selectTab = useCallback((value) => {
    const index = Number(value);
    const tab = Number.isInteger(index) ? tabs[index] : null;
    if (!tab || tab.active === false) return;
    if (typeof tab.onSelect === "function") { tab.onSelect(); return; }
    const current = new URLSearchParams(location.search);
    const next = mergeSearchParams ? mergeSearchParams(current) : current;
    clearParams.forEach((key) => next.delete(key));
    next.set("tab", tab.tabKey || String(index));
    if (next.toString() === new URLSearchParams(location.search).toString()) return;
    navigate({ pathname: location.pathname, search: `?${next}`, hash: location.hash }, { preventScrollReset: true });
  }, [tabs, location.pathname, location.search, location.hash, navigate, clearParams, mergeSearchParams]);

  return [selectedTab, selectTab];
}
